import React from 'react'
import "../Text/Text.css";
const Text3 = () => {
  return (
    <>
       <div className="text-center p-8 ib">
      <h2 className="text-2xl font-bold mb-4 he">Your Journey, Just Got an Upgrade</h2>
      <div className='text-fl'>
      <div className='text-text'>
      {/*-
  <p className="het">If you’ve never experienced business or first class, we partner with top international airlines to secure the best deals. Your journey is elevated with chauffeured pickups, fast-track security, and seamless luxury transfers, making travel effortless.</p>
  <p className="het">On board, relax in a spacious, private cabin away from the crowds. Enjoy premium perks like lie-flat beds and exclusive amenity kits, ensuring you arrive refreshed and ready for your destination.</p>
-*/}

  <p className="het">Flying business class isn’t just about the flight—it’s about the entire experience. Journey Experts makes luxury travel affordable, booking premium flights with world-class airlines.</p>
  <p className="het">From doorstep pick-up and fast-track airport services to spacious cabins, lie-flat beds, and pampering amenity kits, we make sure every moment of your journey is smooth, relaxing, and unforgettable.</p>
</div>

      <img src='/tc.jpg' className='text-im' alt='experience-img'/>
      </div>
    </div>  
  
    <div className="text-center p-8">
  <h2 className="text-2xl font-bold mb-4 he">Indulge in Luxury with Business Class Flights</h2>
 {/*- <p className="het">From the moment you leave home, first-class travel offers unmatched luxury. We arrange chauffeured transfers in premium vehicles and secure tickets that grant you priority security clearance for a seamless airport experience.</p>
  <p className="het">Once on board, settle into a fully reclining seat with ample legroom, entertainment options, and a private space to work or unwind. Enjoy a glass of champagne while choosing from a gourmet menu crafted by top chefs.</p>
  <p className="het">Have dietary preferences or special requests? Just Fly Business ensures every detail is tailored to your needs for a flawless first-class experience.</p>

-*/}
  <p className="het"> Luxury isn’t just a word—it’s an experience, and we bring it to life from the moment your journey begins</p>
  <p className="het">Arrive at the airport in a chauffeured luxury car, skip the lines with priority services, and board your business-class flight stress-free. Sink into a fully reclining seat with ample space, sip on a glass of fine champagne, and indulge in a gourmet menu created by top chefs. </p>
  <p className="het">Need personalized arrangements? From dietary preferences to extra comforts, we ensure your experience is nothing short of perfection.</p>
</div>

    </>
  )
}

export default Text3